module.exports = __webpack_public_path__ + "img/1_cobe.38b3a17c.jpg";